
import { mapList } from 'common/util';

export default {
	setCurrentUser(state, user)
	{
		if (user == null)
			state.currentUser = null;
		else
			state.currentUser = { ...user };
	},

	setProductOptionTypes(state, list)
	{
		var { ids, objects: types } = mapList(list);
		state.productOptionTypes = types;
		state.productOptionTypeIds = ids;
	}
}